class ConstantsCheckout {
  constructor() {
    this.DEFAULT = {
      LIABILITY_PERCENTAGE: 100,
    };

    this.PAYMENT = {
      BANK_SLIP: 'bank_slip',
      CARD: 'card',
    };

    this.PLAN_DESCRIPTION = {
      FEATHER: 'Pequeno',
      LIGHTWT: 'Médio',
      AVERAGE: 'Grande',
    };

    this.GREENFRIDAYCUPONS = {
      TWENTY_TWO: 'GREEN22',
      FIFTY: 'GREEN50',
      ONE_HUNDRED: 'GREEN100',
      TWO_HUNDRED: 'GREEN200',
    };
  }
}

export default new ConstantsCheckout();
